'use strict';

angular.module('mobile-apps')
	.directive('entryWarningsDetailed',['$compile', '$http', '$templateCache', 'EntryWarnings', function($compile, $http, $templateCache, EntryWarnings) {
		return {
			scope:
			{
				// Information: The optional values are needed depending on the
				//              the fields and the check-functions which run
				//              for it. If a check-function needs for example the
				//              base value it has to be supplied to functon correctly.

				// An base entry to compare values to (optional)
				base: '=',
				// The main entry we check the values of
				entry: '=',
				// Fields we want to display warnings for. Options: draft, source, target
				fields: '@',
				// Object with information about the entry and base language {base: 'en', entry: 'de'}
				languages: '=',
				// The properties we want to watch for changes (optional)
				watchProperties: '@'
			},
			link: function (scope, elem, attrs) {

				if (!scope.fields) {
					// If there are no fields defined to display warnings for
					// there is no need to display the directive.
					return;
				}
				var warningFields = scope.fields.split(',');

				var watchProperties = [];
				if (scope.watchProperties) {
					watchProperties = scope.watchProperties.split(',');
				}

				// Data for the check-functions
				var checkData = {
					base: scope.base,
					entry: scope.entry,
					isMasterLang: false,
					languages: scope.languages
				};

				if (checkData && checkData.languages && checkData.languages.base && checkData.languages.entry) {
					checkData.isMasterLang = checkData.languages.base === checkData.languages.entry;
				}

				// Defines the check functions that are supposed to run for which check
				// and for which fields they are able to be run
				var checkFunctions = {
					glossary: {
						fields: ['draft', 'target'],
						checkFunction: EntryWarnings.checkFunctions.glossaryCheckFunction,
						canRunInBaseLanguage: true
					},
					sourceStringChanged: {
						fields: ['source'],
						checkFunction: EntryWarnings.checkFunctions.sourceStringChangedCheckFunction,
						canRunInBaseLanguage: false
					},
					maxLength: {
						fields: ['draft', 'target'],
						checkFunction: EntryWarnings.checkFunctions.maxLengthCheckFunction,
						canRunInBaseLanguage: true
					},
					variableMissing: {
						fields: ['draft', 'target'],
						checkFunction: EntryWarnings.checkFunctions.variableMissingCheckFunction,
						canRunInBaseLanguage: false
					}
				};


				/**
				 * Returns all the warning messages for the given check that
				 * is supposed to run
				 * @param check The name of the check that should run
				 * @returns {Array}
				 */
				scope.getWarning = function(check) {
					var fieldCheckFunctions = {};

					if (!checkFunctions.hasOwnProperty(check)) {
						// If the check is unknown we can not do anything
						return [];
					}

					checkFunctions[check].fields.forEach(function(fieldName) {
						// Check if the function should run for the field (for example: "draft")
						if (warningFields.indexOf(fieldName) !== -1) {
							// Check should run
							if (!fieldCheckFunctions.hasOwnProperty(fieldName)) {
								fieldCheckFunctions[fieldName] = [];
							}
							fieldCheckFunctions[fieldName].push(checkFunctions[check].checkFunction);
						}
					});

					return EntryWarnings.runCheckFunctions(warningFields, checkData, fieldCheckFunctions);
				};


				/**
				 * Returns if there are any warnings for the given check
				 * @param check The check to run
				 * @returns {boolean}
         		 */
				scope.hasWarning = function(check) {
					if (scope.getWarning(check).length === 0) {
						return false;
					}

					return true;
				};


				/**
				 * Returns the warning text to display for the given check
				 * @param check The check to run
				 * @returns {*}
         		 */
				scope.getWarningText = function(check) {
					var warningMessages = scope.getWarning(check);
					if (warningMessages.length === 0) {
						return 'No issue'
					} else if (warningMessages.length === 1) {
						return warningMessages[0];
					} else if (warningMessages.length > 1) {
						return '-' + warningMessages.join('\n-');
					}
				};


				/**
				 * Re-renders the directive with the new data
				 */
				var renderDirective = function(html) {
					// Display the directive with the current data
					var compiledHtml = $compile(html)(scope);
					elem.html(compiledHtml);
				};

				var templateUrl = 'modules/mobile-apps/views/entry-warnings-detailed.client.view.html';

				// Load the template file once
				$http.get(templateUrl, {cache: $templateCache}).then(function(response) {
					if (watchProperties.length === 0) {
						// If there are no specific properties to watch defined
						// we simply watch all of them
						scope.$watch('entry', function() {
							renderDirective(response.data);
						}, true);
					} else {
						// We have specific properties to watch
						watchProperties.forEach(function(propertyName) {
							if (propertyName) {
								scope.$watch('entry.' + propertyName, function() {
									renderDirective(response.data);
								});
							}
						});
					}

					// If we have a base value we are only interested if a few
					// properties change. So we just watch for them.
					var baseWatchProperties = ['value'];
					baseWatchProperties.forEach(function(propertyName) {
						if (propertyName) {
							scope.$watch('base.' + propertyName, function() {
								renderDirective(response.data);
							});
						}
					});

				});

			}
		};
	}]);
